import React, { useState, useEffect } from "react";
import ApiServicesLogin from "../../services/apiLogin";
import Header from "../../components/Header";
import "./styles.css";
import { phone, cnpj, cpf, cpfCnpj } from "../../services/mask";
import { validaCpfCnpj } from "../../services/validaCpfCnpj";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { message } from "antd";
import lang from "../../assets/idioma/idiomas";
import {
  buscarUsuarios,
  detalhesUsuario,
  editarUsuario,
  listarPermissoes,
  logarUsuario,
} from "../../services/http/usuariosService";
import { trackPromise } from "react-promise-tracker";
import globals from "../../globlas";

export default function UsuarioNovoEditar() {
  // Estados do formulário
  const [dadosFormulario, setDadosFormulario] = useState({
    id: "",
    nome: "",
    nomeUsuario: "",
    email: "",
    telefone: "",
    numeroTelefone: "",
    senha: "",
    confirmarSenha: "",
    status: "Pendente", // Valor padrão como string
    perfil: "Participante", // Valor padrão para novos usuários
    nivelAcesso: "Participante",
    cpfCnpj: "",
    dataCadastro: "",
  });

  // Estados de controle
  const [permissoes, setPermissoes] = useState([]);
  const [erros, setErros] = useState({});
  const [cpfCnpjValido, setCpfCnpjValido] = useState(false);
  const [idUsuario, setIdUsuario] = useState(null);
  const [permissoesUsuario, setPermissoesUsuario] = useState([]);
  const [listaPermissoesDisponiveis, setListaPermissoesDisponiveis] = useState(
    []
  );
  const [permissoesCarregadas, setPermissoesCarregadas] = useState(false);

  // Hooks do React Router
  const history = useHistory();
  const { id } = useParams();

  // Efeitos
  useEffect(() => {
    if (id && permissoesCarregadas) {
      carregarDadosUsuario();
    }
  }, [id, permissoesCarregadas]);

  useEffect(() => {
    console.log("Dados do formulário atualizados:", dadosFormulario);
  }, [dadosFormulario]);

  useEffect(() => {
    if (!permissoesCarregadas) {
      carregarListaPermissoes();
    }
  }, []);

  // Funções principais
  const carregarDadosUsuario = async () => {
    try {
      const resposta = await ApiServicesLogin.apiGet(
        `Usuario/detalhe-usuario/${id}`
      );

      // Formatar data de cadastro para exibição em português brasileiro
      let dataFormatada = "";
      if (resposta.dataCadastro) {
        const data = new Date(resposta.dataCadastro);
        dataFormatada = data.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      }

      const dadosMapeados = {
        id: resposta.id || "",
        nome: resposta.nome || "",
        // Login sempre vinculado ao e-mail do usuário
        nomeUsuario: resposta.email || resposta.login || "",
        email: resposta.email || "",
        telefone: resposta.telefone || "",
        numeroTelefone: resposta.phoneNumber || resposta.telefone || "",
        perfil: resposta.perfil || resposta.nivelAcesso || "",
        nivelAcesso: resposta.nivelAcesso || resposta.perfil || "",
        status:
          resposta.status === false
            ? "Inativo"
            : resposta.status === true
            ? "Ativo"
            : "Pendente",
        cpfCnpj: resposta.cpfCnpj || "",
        dataCadastro: dataFormatada,
      };

      setDadosFormulario(dadosMapeados);

      if (resposta.permissoes && Array.isArray(resposta.permissoes)) {
        atualizarPermissoesUsuario(resposta.permissoes);
      }

      buscarUsuarioPorLogin(resposta.login || "");
    } catch (erro) {
      console.error("Erro ao carregar dados do usuário:", erro);
    }
  };

  const buscarUsuarioPorLogin = (nomeUsuario) => {
    if (!nomeUsuario) {
      console.warn("Nome de usuário não fornecido para busca");
      return;
    }

    trackPromise(
      buscarUsuarios()
        .then((resposta) => {
          const usuario = resposta.data.lista.find(
            (usuario) => usuario.login === nomeUsuario
          );
          if (usuario) {
            setIdUsuario(usuario);
            buscarDetalhesUsuario(usuario.id);
          } else {
            console.warn(
              `Usuário com login '${nomeUsuario}' não encontrado na lista`
            );
          }
        })
        .catch((erro) => {
          console.error("Erro ao buscar usuários:", erro);
        })
    );
  };

  const carregarListaPermissoes = () => {
    trackPromise(
      listarPermissoes()
        .then((resposta) => {
          if (resposta.data && Array.isArray(resposta.data)) {
            const permissoesComEstado = resposta.data.map((permissao) => ({
              ...permissao,
              marcada: false,
            }));
            setListaPermissoesDisponiveis(permissoesComEstado);
            setPermissoesCarregadas(true);
          }
        })
        .catch((erro) => {
          console.error("Erro ao carregar permissões:", erro);
        })
    );
  };

  const atualizarPermissoesUsuario = (permissoesDoUsuario) => {
    setPermissoesUsuario(permissoesDoUsuario);

    setListaPermissoesDisponiveis((listaAnterior) =>
      listaAnterior.map((permissao) => ({
        ...permissao,
        marcada: permissoesDoUsuario.some((p) => p.id === permissao.id),
      }))
    );
  };

  const buscarDetalhesUsuario = (idUsuario) => {
    trackPromise(
      detalhesUsuario(idUsuario)
        .then((resposta) => {
          if (!resposta.fail && resposta.data && resposta.data.permissoes) {
            atualizarPermissoesUsuario(resposta.data.permissoes);
          }
        })
        .catch((erro) => {
          console.error("Erro ao buscar detalhes do usuário:", erro);
        })
    );
  };

  const alterarPermissao = (item, marcada) => {
    const listaAtualizada = listaPermissoesDisponiveis.map((permissao) =>
      permissao.id === item.id ? { ...permissao, marcada } : permissao
    );
    setListaPermissoesDisponiveis(listaAtualizada);

    const permissoesAtualizadas = marcada
      ? [...permissoesUsuario, { id: item.id, permissao: item.permissao }]
      : permissoesUsuario.filter((p) => p.id !== item.id);
    setPermissoesUsuario(permissoesAtualizadas);
  };

  // Validação do formulário
  const validarFormulario = () => {
    const novosErros = {};

    // Validação do nome (obrigatório para novo usuário)
    if (!id && !dadosFormulario.nome?.trim()) {
      novosErros.nome = "Nome é obrigatório";
    }

    // Validação do nome de usuário (obrigatório para edição)
    if (id && !dadosFormulario.nomeUsuario?.trim()) {
      novosErros.nomeUsuario = "Usuário é obrigatório";
    }

    // Validação do email (obrigatório sempre)
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!dadosFormulario.email?.trim()) {
      novosErros.email = "Email é obrigatório";
    } else if (!regexEmail.test(dadosFormulario.email)) {
      novosErros.email = "Email inválido";
    }

    // Validação do telefone (obrigatório para novo usuário)
    if (!id && !dadosFormulario.numeroTelefone?.trim()) {
      novosErros.numeroTelefone = "Telefone é obrigatório";
    }

    // Validação do CPF/CNPJ (obrigatório para novo usuário)
    if (!id && !dadosFormulario.cpfCnpj?.trim()) {
      novosErros.cpfCnpj = "CPF/CNPJ é obrigatório";
    } else if (dadosFormulario.cpfCnpj && dadosFormulario.cpfCnpj.length > 0) {
      if (
        dadosFormulario.cpfCnpj.length !== 11 &&
        dadosFormulario.cpfCnpj.length !== 14
      ) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
      } else if (!validaCpfCnpj(dadosFormulario.cpfCnpj)) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
      }
    }

    // Validação da senha (apenas para edição, quando preenchida)
    if (dadosFormulario.senha && dadosFormulario.senha.length < 6) {
      novosErros.senha = "A senha deve ter pelo menos 6 caracteres";
    }

    if (
      dadosFormulario.senha &&
      dadosFormulario.senha !== dadosFormulario.confirmarSenha
    ) {
      novosErros.confirmarSenha = "As senhas não coincidem";
    }

    // Validação do perfil (obrigatório para novo usuário)
    if (
      !id &&
      !dadosFormulario.perfil?.trim() &&
      !dadosFormulario.nivelAcesso?.trim()
    ) {
      novosErros.perfil = "Perfil ou Nível de Acesso é obrigatório";
    }

    // Validação de permissões (pelo menos uma deve ser selecionada para novo usuário)
    if (!id && dadosFormulario.perfil === "Participante") {
      const permissoesSelecionadas = listaPermissoesDisponiveis.filter(
        (elemento) => elemento.id !== "todos" && elemento.marcada
      );
      if (permissoesSelecionadas.length === 0) {
        novosErros.permissoes = "Selecione pelo menos uma permissão";
      }
    }

    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };
  useEffect(() => {
    console.log("dadosFormulario", dadosFormulario);
  }, [dadosFormulario]);
  // Manipulador de mudanças nos campos
  const alterarCampo = (evento) => {
    const { name, value, type, checked } = evento.target;

    if (name === "status") {
      setDadosFormulario((anterior) => ({
        ...anterior,
        status: value,
      }));
    }
    if (name === "perfil") {
      setDadosFormulario((anterior) => ({
        ...anterior,
        nivelAcesso: value,
        perfil: value,
      }));

      if (value === "Administrador") {
        setListaPermissoesDisponiveis((listaAnterior) =>
          listaAnterior.map((permissao) => ({
            ...permissao,
            marcada: true,
          }))
        );
        // Atualizar permissões do usuário com todas as permissões
        const todasPermissoes = listaPermissoesDisponiveis
          .filter((p) => p.id !== "todos")
          .map((p) => ({ id: p.id, permissao: p.permissao }));
        setPermissoesUsuario(todasPermissoes);
      } else if (value === "Midia") {
        setListaPermissoesDisponiveis((listaAnterior) =>
          listaAnterior.map((permissao) => ({
            ...permissao,
            marcada: false,
          }))
        );
        setPermissoesUsuario([]);
      }
    }
    if (name === "numeroTelefone" || name === "cpfCnpj") {
      const valorNumerico = value.replace(/\D/g, "");
      setDadosFormulario((anterior) => ({
        ...anterior,
        [name]: valorNumerico,
      }));
    } else if (name === "email") {
      // O login do usuário é sempre igual ao e-mail cadastrado
      setDadosFormulario((anterior) => ({
        ...anterior,
        email: value,
        nomeUsuario: value,
      }));
    } else {
      setDadosFormulario((anterior) => ({
        ...anterior,
        [name]: type === "checkbox" ? checked : value,
      }));
    }

    // Validação em tempo real para CPF/CNPJ
    if (name === "cpfCnpj") {
      const valorNumerico = value.replace(/\D/g, "");
      const novosErros = { ...erros };

      delete novosErros.cpfCnpj;

      if (
        valorNumerico.length > 0 &&
        valorNumerico.length !== 11 &&
        valorNumerico.length !== 14
      ) {
        novosErros.cpfCnpj =
          "CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos";
        setCpfCnpjValido(false);
      } else if (valorNumerico.length > 0 && !validaCpfCnpj(valorNumerico)) {
        novosErros.cpfCnpj = "CPF/CNPJ inválido";
        setCpfCnpjValido(false);
      } else if (valorNumerico.length === 11 || valorNumerico.length === 14) {
        setCpfCnpjValido(true);
      } else {
        setCpfCnpjValido(false);
      }

      setErros(novosErros);
    } else {
      if (erros[name]) {
        setErros((anterior) => ({
          ...anterior,
          [name]: undefined,
        }));
      }
    }
  };
  // Salvar permissões
  const salvarPermissoes = async () => {
    try {
      const dadosPermissoes = {
        id: idUsuario.id,
        email: dadosFormulario.email,
        login: dadosFormulario.email,
        nivelAcesso: "Participante",
      };

      const arrayPermissoes = [];

      listaPermissoesDisponiveis.forEach((elemento) => {
        if (elemento.id !== "todos" && elemento.marcada) {
          arrayPermissoes.push({
            id: elemento.id,
            permissao: elemento.permissao,
          });
        }
      });

      dadosPermissoes.permissoes = arrayPermissoes;

      await editarUsuario(dadosPermissoes);
    } catch (erro) {
      console.error("Erro ao salvar permissões:", erro);
      throw erro;
    }
  };

  // Limpar e formatar dados para a API
  const limparDadosParaAPI = (dados) => {
    return {
      login: dados.login?.trim() || "",
      email: dados.email?.trim() || "",
      perfil: dados.perfil?.trim() || "",
      nivelAcesso: dados.nivelAcesso?.trim() || "",
      isAdmin: Boolean(dados.isAdmin),
      nome: dados.nome?.trim() || "",
      cpfCnpj: dados.cpfCnpj?.trim() || "",
      telefone: dados.telefone?.trim() || "",
      status: dados.status,
      ...(dados.senha && { senha: dados.senha?.trim() }),
      permissoes: Array.isArray(dados.permissoes)
        ? dados.permissoes.map((p) => ({
            id: p.id?.toString() || "",
            nome: p.nome?.trim() || "",
            status: Boolean(p.status),
          }))
        : [],
    };
  };

  // Validação específica para o formato da API
  const validarFormatoAPI = (dados) => {
    const erros = [];

    // Validar campos obrigatórios
    if (!dados.login?.trim()) {
      erros.push("Login é obrigatório");
    }

    if (!dados.email?.trim()) {
      erros.push("Email é obrigatório");
    }
    if (!dados.perfil?.trim() && !dados.nivelAcesso?.trim()) {
      erros.push("Perfil ou Nível de Acesso é obrigatório");
    }

    if (typeof dados.isAdmin !== "boolean") {
      erros.push("isAdmin deve ser um valor booleano");
    }

    if (!dados.nome?.trim()) {
      erros.push("Nome é obrigatório");
    }

    if (!dados.cpfCnpj?.trim()) {
      erros.push("CPF/CNPJ é obrigatório");
    }

    if (!dados.telefone?.trim()) {
      erros.push("Telefone é obrigatório");
    }

    // Senha validada apenas quando preenchida (edição)
    if (id && dados.senha && dados.senha.trim().length < 6) {
      erros.push("Senha deve ter pelo menos 6 caracteres");
    }

    // Validar array de permissões
    if (!Array.isArray(dados.permissoes)) {
      erros.push("Permissões deve ser um array");
    } else {
      if (dados.perfil === "Participante" && dados.permissoes.length === 0) {
        erros.push("Pelo menos uma permissão deve ser selecionada");
      }

      dados.permissoes.forEach((permissao, index) => {
        if (!permissao.id?.trim()) {
          erros.push(`Permissão ${index + 1}: ID é obrigatório`);
        }
        if (!permissao.nome?.trim()) {
          erros.push(`Permissão ${index + 1}: Nome é obrigatório`);
        }
        if (typeof permissao.status !== "boolean") {
          erros.push(`Permissão ${index + 1}: Status deve ser booleano`);
        }
      });
    }

    return erros;
  };

  // Verifica se o e-mail já está vinculado a outro usuário (unicidade)
  const emailJaCadastrado = async () => {
    try {
      const resposta = await buscarUsuarios();
      const lista = resposta?.data?.lista || [];
      const emailAlvo = dadosFormulario.email.trim().toLowerCase();
      return lista.some(
        (usuario) =>
          (usuario.email || "").trim().toLowerCase() === emailAlvo &&
          String(usuario.id) !== String(id || "")
      );
    } catch (erro) {
      console.error("Erro ao validar unicidade do e-mail:", erro);
      // Em caso de falha na verificação, deixa a validação para o backend
      return false;
    }
  };

  // Submissão do formulário
  const enviarFormulario = async (evento) => {
    evento.preventDefault();

    if (!validarFormulario()) {
      return;
    }

    // Garante que cada e-mail seja único no portal
    if (await emailJaCadastrado()) {
      setErros((anterior) => ({
        ...anterior,
        email: "Este e-mail já está cadastrado no portal",
      }));
      message.error("Este e-mail já está cadastrado no portal.");
      return;
    }

    try {
      if (id) {
        // Edição de usuário existente
        const permissoesSelecionadas = listaPermissoesDisponiveis
          .filter((elemento) => elemento.id !== "todos" && elemento.marcada)
          .map((elemento) => ({
            id: elemento.id,
            nome: elemento.permissao,
            status: true,
          }));

        // Determinar se é admin baseado no perfil selecionado
        const isAdmin = dadosFormulario.perfil === "Administrador";

        // Determinar o status correto (string)

        const dadosBrutos = {
          login: dadosFormulario.email,
          email: dadosFormulario.email,
          nivelAcesso: dadosFormulario.nivelAcesso,
          perfil: dadosFormulario.perfil,
          isAdmin: isAdmin,
          nome: dadosFormulario.nome,
          cpfCnpj: dadosFormulario.cpfCnpj,
          senha: dadosFormulario.senha,
          telefone: dadosFormulario.numeroTelefone,
          status:
            dadosFormulario.status === "Ativo"
              ? true
              : dadosFormulario.status === "Inativo"
              ? false
              : null,
          ...(dadosFormulario.senha && { senha: dadosFormulario.senha }),
          permissoes: permissoesSelecionadas,
        };

        // Limpar e formatar dados para a API
        const dadosParaEnvio = limparDadosParaAPI(dadosBrutos);

        // Validar formato da API antes de enviar
        const errosAPI = validarFormatoAPI({ ...dadosParaEnvio });
        if (errosAPI.length > 0) {
          message.error(`Erros de validação: ${errosAPI.join(", ")}`);
          return;
        }

        await ApiServicesLogin.apiPost(`Usuario/editar-usuario`, {
          ...dadosParaEnvio,
          id: id,
        });
        message.success(lang.Participante_alterado_com_sucesso);
        history.push("/usuario");
        if (dadosFormulario.perfil === "Participante") {
          await salvarPermissoes();
        }
      } else {
        // Novo cadastro de usuário
        const permissoesSelecionadas = listaPermissoesDisponiveis
          .filter((elemento) => elemento.id !== "todos" && elemento.marcada)
          .map((elemento) => ({
            id: elemento.id,
            nome: elemento.permissao,
            status: true,
          }));

        // Determinar se é admin baseado no perfil selecionado
        const isAdmin = dadosFormulario.perfil === "Administrador";

        const dadosBrutos = {
          login: dadosFormulario.email,
          email: dadosFormulario.email,
          perfil: dadosFormulario.perfil,
          isAdmin: isAdmin,
          nome: dadosFormulario.nome,
          cpfCnpj: dadosFormulario.cpfCnpj,
          telefone: dadosFormulario.numeroTelefone,
          status:
            dadosFormulario.status === "Ativo"
              ? true
              : dadosFormulario.status === "Inativo"
              ? false
              : null,
          senha: dadosFormulario.senha,
          permissoes: permissoesSelecionadas,
        };

        // Limpar e formatar dados para a API
        const dadosParaEnvio = limparDadosParaAPI(dadosBrutos);

        // Validar formato da API antes de enviar
        const errosAPI = validarFormatoAPI(dadosParaEnvio);
        if (errosAPI.length > 0) {
          message.error(`Erros de validação: ${errosAPI.join(", ")}`);
          return;
        }

        await ApiServicesLogin.apiPost("Usuario", dadosParaEnvio);
        message.success("Participante cadastrado com sucesso! Um e-mail de ativação foi enviado.");
      }

      history.push("/usuario");
    } catch (erro) {
      console.error("Erro ao salvar usuário:", erro);

      // Verificar se é um erro de usuário já existente
      if (erro.response?.data?.message) {
        message.error(erro.response.data.message);
      }
    }
  };

  // Função de integração (mantida como estava)
  const fazerLoginIntegracao = async (SSO, BEARER) => {
    const dados = { encriptedValueAes: SSO };
    try {
      await fetch(`${globals.REACT_APP_URL_BASE_API}AutenticarUsuario/login`, {
        method: "POST",
        body: JSON.stringify(dados),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${BEARER}`,
        },
      });

      message.success(lang.Participante_cadastrado_com_sucesso);
    } catch (erro) {
      console.error("Erro ao integrar com mídia center:", erro);
    }
  };

  return (
    <>
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />

      <div className="container">
        <h1 className="title">{id ? "Editar Usuário" : "Novo Usuário"}</h1>
        <form onSubmit={enviarFormulario} className="admin-form">
          <div className="form-section">
            <h2>Dados Pessoais</h2>
            <div className="row">
              {/* NOME */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Nome</label>
                  <input
                    type="text"
                    name="nome"
                    value={dadosFormulario.nome}
                    onChange={alterarCampo}
                    required={!id}
                    className={`form-control ${erros.nome ? "is-invalid" : ""}`}
                  />
                  {erros.nome && (
                    <div className="invalid-feedback">{erros.nome}</div>
                  )}
                </div>
              </div>
              {/* EMAIL */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    disabled={id}
                    name="email"
                    value={dadosFormulario.email}
                    onChange={alterarCampo}
                    required
                    className={`form-control ${
                      erros.email ? "is-invalid" : ""
                    }`}
                  />
                  {erros.email && (
                    <div className="invalid-feedback">{erros.email}</div>
                  )}
                </div>
              </div>
              {/* STATUS */}
              <div className="col-md-6 col-lg-2 mb-3">
                <div className="form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={dadosFormulario.status}
                    onChange={alterarCampo}
                    className={`form-control ${
                      erros.status ? "is-invalid" : ""
                    }`}
                  >
                    <option value="Pendente">Pendente</option>
                    <option value="Ativo">Ativo</option>
                    <option value="Inativo">Inativo</option>
                  </select>
                  {erros.status && (
                    <div className="invalid-feedback">{erros.status}</div>
                  )}
                </div>
              </div>
              {/* PERFIL */}
              <div className="col-md-6 col-lg-2 mb-3">
                <div className="form-group">
                  <label>
                    Perfil {!id && <span className="required">*</span>}
                  </label>
                  <select
                    name="perfil"
                    value={dadosFormulario.perfil}
                    onChange={alterarCampo}
                    required={!id}
                    className={`form-control ${
                      erros.perfil ? "is-invalid" : ""
                    }`}
                  >
                    <option value="Participante">Participante</option>
                    <option value="Administrador">Administrador</option>
                    <option value="Midia">Mídia</option>
                  </select>
                  {erros.perfil && (
                    <div className="invalid-feedback">{erros.perfil}</div>
                  )}
                </div>
              </div>
              {/* CPF/CNPJ */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>CPF/CNPJ</label>
                  <input
                    type="text"
                    name="cpfCnpj"
                    value={cpfCnpj(dadosFormulario.cpfCnpj)}
                    onChange={alterarCampo}
                    required={!id}
                    maxLength={18}
                    className={`form-control ${
                      erros.cpfCnpj
                        ? "is-invalid"
                        : cpfCnpjValido
                        ? "is-valid"
                        : ""
                    }`}
                  />
                  {erros.cpfCnpj && (
                    <div className="invalid-feedback">{erros.cpfCnpj}</div>
                  )}
                  {cpfCnpjValido && !erros.cpfCnpj && (
                    <div className="valid-feedback">CPF/CNPJ válido</div>
                  )}
                </div>
              </div>
              {/* USUARIO */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Usuário</label>
                  <input
                    type="text"
                    disabled
                    name="nomeUsuario"
                    value={dadosFormulario.email}
                    className="form-control"
                    style={{
                      backgroundColor: "#f8f9fa",
                      cursor: "not-allowed",
                    }}
                  />
                  <small className="form-text text-muted">
                    Preenchido automaticamente com o e-mail informado.
                  </small>
                </div>
              </div>
              {/* TELEFONE */}
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>Telefone</label>
                  <input
                    type="text"
                    name="numeroTelefone"
                    value={phone(dadosFormulario.numeroTelefone)}
                    onChange={alterarCampo}
                    required={!id}
                    className={`form-control ${
                      erros.numeroTelefone ? "is-invalid" : ""
                    }`}
                  />
                  {erros.numeroTelefone && (
                    <div className="invalid-feedback">
                      {erros.numeroTelefone}
                    </div>
                  )}
                </div>
              </div>
              {/* DATA DE CADASTRO */}
              {id && (
                <div className="col-md-6 col-lg-4 mb-3">
                  <div className="form-group">
                    <label>Data de Cadastro</label>
                    <input
                      type="text"
                      name="dataCadastro"
                      value={dadosFormulario.dataCadastro}
                      disabled
                      className="form-control"
                      style={{
                        backgroundColor: "#f8f9fa",
                        cursor: "not-allowed",
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {id && (
          <div className="form-section">
            <h2>Dados de Acesso</h2>
            <div className="row">
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>
                    Senha
                  </label>
                  <input
                    type="password"
                    name="senha"
                    value={dadosFormulario.senha}
                    onChange={alterarCampo}
                    className={`form-control ${
                      erros.senha ? "is-invalid" : ""
                    }`}
                    placeholder="Deixe em branco para manter a senha atual"
                  />
                  {erros.senha && (
                    <div className="invalid-feedback">{erros.senha}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-lg-4 mb-3">
                <div className="form-group">
                  <label>
                    Confirmar Senha
                  </label>
                  <input
                    type="password"
                    name="confirmarSenha"
                    value={dadosFormulario.confirmarSenha}
                    onChange={alterarCampo}
                    className={`form-control ${
                      erros.confirmarSenha ? "is-invalid" : ""
                    }`}
                    placeholder="Deixe em branco para manter a senha atual"
                  />
                  {erros.confirmarSenha && (
                    <div className="invalid-feedback">
                      {erros.confirmarSenha}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          )}
          {dadosFormulario.perfil === "Participante" && (
            <div className="form-section">
              <h2 style={{ fontWeight: "bold" }}>Permissões de Visualização</h2>
              {erros.permissoes && (
                <div className="alert alert-danger" role="alert">
                  {erros.permissoes}
                </div>
              )}
              <div className="row">
                <div className="row">
                  {listaPermissoesDisponiveis
                    .filter((item) => item.permissao !== "Participante")
                    .map((item) => (
                      <div
                        key={item.id}
                        className="col-auto mb-3"
                        onClick={(e) => {
                          e.stopPropagation();
                          alterarPermissao(item, !item.marcada);
                        }}
                      >
                        <div
                          className={`permission-item card h-100 ${
                            item.marcada ? "selected" : ""
                          }`}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="form-check d-flex align-items-center">
                            <input
                              type="checkbox"
                              className="mr-2"
                              id={`permission-${item.id}`}
                              checked={item.marcada}
                              readOnly
                              style={{ cursor: "pointer" }}
                              tabIndex={-1}
                            />
                            <span>{item.permissao}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          )}
          <div className="row justify-content-center mt-4">
            <div className="col-md-3 col-sm-6 mb-3">
              <button
                type="button"
                onClick={() => history.push("/usuario")}
                className="btn btn-secondary w-100"
              >
                Cancelar
              </button>
            </div>
            <div className="col-md-3 col-sm-6 mb-3">
              <button type="submit" className="btn btn-primary w-100">
                {id ? "Atualizar" : "Salvar"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
